import {
  List,
  ListItem,
  Stack,
  styled,
  Typography,
  type CSSObject,
} from '@mui/material';
import underlineStroke from '../../../public/webp/fromPNG/underline-stroke.webp';

export const StyledStack = styled(Stack)(({ theme }) => ({
  flexFlow: 'column nowrap',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(12, 0, 24),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(8, 0),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(6, 0),
  },
}));

export const StyledTwoTitles = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(3),
  alignItems: 'flex-start',
  zIndex: '1',
  marginBottom: theme.spacing(6),
  [theme.breakpoints.down('sm')]: {
    gridAutoFlow: 'row',
    marginBottom: theme.spacing(4),
  },
}));

export const StyledFirstTitle = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  display: 'flex',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
    alignSelf: 'center',
  },
}));

export const StyledServiceItem = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
}));

export const StyledServiceTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.PRIMARY,
  b: {
    whiteSpace: 'nowrap',
    position: 'relative',
    ['&:after']: {
      content: "''",
      display: 'block',
      backgroundImage: `url(${underlineStroke})`,
      backgroundSize: '100%',
      backgroundRepeat: 'no-repeat',
      height: '100%',
      width: '100%',
      position: 'absolute',
      left: '0%',
    },
  },
  [theme.breakpoints.down('sm')]: {
    textAlign: 'left',
  },
}));

export const StyledList = styled(List)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    paddingLeft: theme.spacing(2.5),
  },
}));

export const StyledListItem = styled(ListItem)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  display: 'list-item',
  listStyleType: 'disc',
  '&::marker': {
    color: theme.palette.aquamarineColors?.PLUS_2,
    fontSize: '2em',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5em',
    },
  },
  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(1),
  },
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(0),
    textAlign: 'left',
  },
}));
